import React from 'react';

export const MusicNote: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    role="img"
    aria-labelledby="instructor-icon"
    stroke="#FFF"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.15}
    >
      <path d="M11.254 21.673V5.87l11.233-2.411v16.346m-11.233-9.334l11.233-2.54M11.214 21.567c-.347-1.158-1.912-1.712-3.492-1.237-1.582.473-2.581 1.796-2.233 2.953.349 1.157 1.912 1.71 3.493 1.237 1.582-.474 2.58-1.796 2.232-2.953z" />
      <path d="M22.443 19.72c-.348-1.158-1.912-1.713-3.493-1.238-1.581.474-2.58 1.796-2.232 2.953.348 1.158 1.912 1.711 3.493 1.238 1.581-.475 2.58-1.796 2.232-2.954z" />
    </g>
  </svg>
);
